import React, { useEffect, useState } from 'react';
import { Marker, MarkerProps } from 'react-map-gl';
import { useTheme } from '@material-ui/core';
import { FaCircle } from 'react-icons/fa';
import { IoIosRadioButtonOn } from 'react-icons/io';

interface ICustomMarker extends MarkerProps {
  iconPriority: string;
  iconStatus: string;
  type: 'filled' | 'outlined';
  onClick?: any;
}

const CustomMarker: React.FC<ICustomMarker> = ({
  iconPriority,
  iconStatus,
  latitude,
  longitude,
  type,
  onClick,
}) => {
  const [color, setColor] = useState('#000');
  const theme = useTheme();

  useEffect(() => {
    if (iconPriority === 'URGENTE') {
      setColor(theme.charts.urgent || '#E55353');
    }

    if (iconPriority === 'ALTA') {
      setColor(theme.charts.high || '#EAAA35');
    }

    if (iconPriority === 'MEDIA') {
      setColor(theme.charts.average || '#E3E338');
    }

    if (iconPriority === 'BAIXA') {
      setColor(theme.charts.low || '#2EB85C');
    }
  }, [iconPriority, iconStatus, theme]);

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      offsetLeft={-9}
      offsetTop={-18}
    >
      {type === 'filled' ? (
        <FaCircle
          onClick={onClick}
          size={18}
          color={color}
          style={{
            boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.5)',
            borderRadius: 9,
          }}
        />
      ) : (
        <IoIosRadioButtonOn
          onClick={onClick}
          size={18}
          color={color}
          style={{
            boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.5)',
            borderRadius: 9,
          }}
        />
      )}
    </Marker>
  );
};

export default React.memo(CustomMarker);
